import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity } from 'react-native';
import { VisualData, resolveTokens } from '@eduwrite/shared';

interface Props {
    data: Extract<VisualData, { type: 'decomposition' }>;
    context: Record<string, number | string>;
    onInput: (input: string) => void;
}

export const DecompositionVisual: React.FC<Props> = ({ data, context, onInput }) => {
    const splitA = data.splitA.map((v) => resolveTokens(String(v), context));
    const splitB = data.splitB?.map((v) => resolveTokens(String(v), context));
    const operator = data.operator;

    const renderChips = (values: string[]) => (
        <View style={styles.chipRow}>
            {values.map((val, i) => (
                <View key={i} style={styles.chip}>
                    <Text style={styles.chipText} allowFontScaling={true} maxFontSizeMultiplier={1.5}>{val}</Text>
                </View>
            ))}
        </View>
    );

    return (
        <View style={styles.container}>
            <View style={styles.row}>
                {renderChips(splitA)}
            </View>
            <Text style={styles.operator} allowFontScaling={true} maxFontSizeMultiplier={1.5}>{operator}</Text>
            {splitB && (
                <View style={styles.row}>
                    {renderChips(splitB)}
                </View>
            )}
            <TouchableOpacity
                style={styles.confirmButton}
                onPress={() => onInput('confirmed')}
                accessibilityRole="button"
                accessibilityLabel="Confirm decomposition"
            >
                <Text style={styles.confirmText} allowFontScaling={true} maxFontSizeMultiplier={1.5}>Tap to confirm</Text>
            </TouchableOpacity>
        </View>
    );
};

const styles = StyleSheet.create({
    container: {
        alignItems: 'center',
        gap: 12,
        padding: 16,
    },
    row: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'center',
        gap: 8,
    },
    chipRow: {
        flexDirection: 'row',
        gap: 8,
    },
    chip: {
        backgroundColor: '#DBEAFE',
        borderRadius: 12,
        paddingHorizontal: 16,
        paddingVertical: 10,
        minWidth: 56,
        alignItems: 'center',
    },
    chipText: {
        fontSize: 20,
        fontWeight: '700',
        color: '#1E40AF',
    },
    operator: {
        fontSize: 28,
        fontWeight: '800',
        color: '#1E293B',
    },
    confirmButton: {
        marginTop: 8,
        backgroundColor: '#22c55e',
        borderRadius: 12,
        paddingHorizontal: 24,
        paddingVertical: 12,
    },
    confirmText: {
        fontSize: 16,
        fontWeight: '700',
        color: '#FFFFFF',
    },
});
